import React from 'react';
import './MaterialTypeGrid.css';

const MaterialTypeGrid = ({ materialTypes, selectedMaterial, onMaterialSelect }) => {
  return (
    <div className="material-type-section">
      <h2 className="section-title">Material Types</h2>
      <div className="type-grid">
        {materialTypes.map((material, index) => (
          <div
            key={material.type}
            className={`type-card ${selectedMaterial?.type === material.type ? 'active' : ''}`}
            onClick={() => onMaterialSelect(material)}
          >
            <div className="type-icon">{material.icon}</div>
            <div className="type-name">{material.type}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MaterialTypeGrid;

